import { type Conversation } from '@atlassian/conversation-assistant-store/controllers/chat/types';

/** Side-nav list items may attach UI-only fields; the chat store `Conversation` type must not persist them. */
export const conversationMetadataForStore = (
	conversation: Conversation & { isEmpty?: unknown; currentTask?: unknown },
): Conversation => {
	const { isEmpty: _isEmpty, currentTask: _currentTask, ...storeConversation } = conversation;
	return storeConversation;
};
